import React from 'react';
import { Callback, NavigationAction } from 'yet-another-react-lightbox';
import {
  INITIAL_TRANSLATE_X,
  SWIPE_THRESHOLD,
  TRANSLATE_X_REG_EXP,
  SLIDE_SELECTOR,
} from '@/components/Gallery/Gallery.constants';
import { TouchStart } from '@/components/Gallery/Gallery.types';

let prevTranslateXValue = '';

export function getSlideImageElement(): HTMLImageElement | null {
  return document.querySelector(SLIDE_SELECTOR) as HTMLImageElement;
}

export function getTranslateXValue(img: HTMLImageElement): string {
  const regex = new RegExp(TRANSLATE_X_REG_EXP);
  const match = img.style.transform.match(regex);

  return match ? match[1] : '';
}

export function calculateDeltas(e: React.TouchEvent, startTouch: TouchStart) {
  const touch = e.changedTouches[0];
  const endX = touch.clientX;
  const endY = touch.clientY;

  if (!startTouch) return { deltaX: 0, deltaY: 0 };

  const deltaX = endX - startTouch.x;
  const deltaY = endY - startTouch.y;

  return { deltaX, deltaY };
}

export function shouldNavigate(deltaX: number, deltaY: number): boolean {
  return (
    Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > SWIPE_THRESHOLD
  );
}

export function handleSwipe(
  deltaX: number,
  translateXValue: string,
  prev?: Callback<NavigationAction | void>,
  next?: Callback<NavigationAction | void>
) {
  if (deltaX > 0) {
    prevIfNeeded(translateXValue, prev);
  } else {
    nextIfNeeded(translateXValue, next);
  }
  prevTranslateXValue = translateXValue;
}

function isImageEnd(translateXValue: string): boolean {
  return (
    prevTranslateXValue !== INITIAL_TRANSLATE_X &&
    translateXValue !== INITIAL_TRANSLATE_X &&
    prevTranslateXValue === translateXValue
  );
}

function prevIfNeeded(
  translateXValue: string,
  prev?: Callback<NavigationAction | void>
) {
  if (isImageEnd(translateXValue) && prev) {
    prev();
  }
}

function nextIfNeeded(
  translateXValue: string,
  next?: Callback<NavigationAction | void>
) {
  if (isImageEnd(translateXValue) && next) {
    next();
  }
}
